import React from 'react'
import { Link } from 'react-router-dom'
import { Table, Space, Button } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import { ListComponent, BaseListComponentProps } from '../BaseComponent'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import { SearchOptions } from '../TableHelper'
import { Pagination } from 'components/Pagination'

type MappingCharacteristicListProps = BaseListComponentProps & {
  loading: boolean,
  mappingCharacteristics: any,
  pagination: any,
  filters: any | null,
  history?: any,

  loadMappingCharacteristics: (args: SearchRequest) => void,

  onLoad?: (searchOptions: SearchOptions) => void
}

export default class MappingCharacteristicList extends ListComponent<MappingCharacteristicListProps> {

  static defaultProps = {
    loading: false,
    mappingCharacteristics: [],

    loadMappingCharacteristics: () => {}
  }

  tableColumns = [
    {
      title: 'Partner',
      dataIndex: 'partner_key',
      key: 'partner_key',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.partner_key - b.name
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a: any, b: any) => a.name - b.name
    },
    {
      title: 'External ID',
      dataIndex: 'external_id',
      key: 'external_id',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.external_id - b.external_id
    },
    {
      title: 'Characteristic',
      dataIndex: ['characteristic', 'name'],
      key: 'characteristic_id',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.characteristic?.name - b.characteristic?.name
    },
    {
      title: 'Shelter',
      dataIndex: ['shelter', 'name'],
      key: 'shelter_id',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.shelter?.name - b.shelter?.name
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text: string, record: any) => (
        <Space size='middle'>
          <Link to={`characteristic/${record.uuid}`} ref={(refs) => this.actionRefs.edit.push(refs)}>
            <Button type="dashed" shape="round" icon={<EditOutlined />} />
          </Link>
        </Space>
      )
    }
  ]

  componentDidUpdate(prevProps: any, prevState: any) {
    this.validateAccessPermissions()

    if (prevProps.filters !== this.props.filters) {
      this.load()
    }
  }
  
  protected load() {
    this.searchOptions = {
      search: {
        ...this.props.filters,
        characteristic: {
          with: true
        },
        shelter: {
          with: {
            _fields: ["id", "uuid", "name"]
          }
        }
      },
      options: {
        ...this.searchOptions.options,
        _force_ids: true,
        sort: ['-id']
      }
    }

    this.props.loadMappingCharacteristics(this.searchOptions)

    if (this.props.onLoad) {
      this.props.onLoad(this.searchOptions)
    }
  }

  render() {
    const { loading, pagination, mappingCharacteristics, loadMappingCharacteristics } = this.props

    return (
      <>
        <Table
          loading={loading}
          rowKey='uuid'
          columns={this.tableColumns}
          pagination={false}
          dataSource={mappingCharacteristics}
          onChange={(pagination: any, filters: any, sorter: any) => this.handleTableChange(pagination, sorter, loadMappingCharacteristics)}
        />
        <Pagination
          loading={loading}
          current={pagination?.page}
          pageSize={pagination?.limit}
          length={mappingCharacteristics?.length}
          onChange={(pagination) =>
            this.handleTableChange(pagination, undefined, loadMappingCharacteristics)
          }
        />
      </>
    )
  }
}
